import { setActionButtons } from 'aria-viewer/tour/tourActions'
import { observeFirstSceneEntered } from 'aria-viewer/utils/epicsCommon'
import 'rxjs/add/operator/mapTo'

const showActionButtons = (action$, store) => {
    // wait 5 seconds, to catch the users attention
    return observeFirstSceneEntered(action$, store, 6000)
        .take(1)
        .mapTo(
            setActionButtons({
                visible: true,
            })
        )
}

export default showActionButtons
